var _excluded = ["allowLeaveFirst", "disabled", "enter", "leave", "onReady", "onStart", "onEnd", "show"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect, useRef } from 'react';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { useCreateAnimation } from './useCreateAnimation';
export function useCSSEnterLeave(element, options) {
  var initRef = useRef(false);

  var allowLeaveFirst = options.allowLeaveFirst,
      disabled = options.disabled,
      _options$enter = options.enter,
      enter = _options$enter === void 0 ? {} : _options$enter,
      _options$leave = options.leave,
      leave = _options$leave === void 0 ? {} : _options$leave,
      onReady = options.onReady,
      onStart = options.onStart,
      onEnd = options.onEnd,
      show = options.show,
      extra = _objectWithoutProperties(options, _excluded);

  var handleReady = useRefCallback(function (identifier) {
    var _a, _b;

    onReady === null || onReady === void 0 ? void 0 : onReady();
    identifier ? (_a = enter.onReady) === null || _a === void 0 ? void 0 : _a.call(enter) : (_b = leave.onReady) === null || _b === void 0 ? void 0 : _b.call(leave);
  });
  var handleStart = useRefCallback(function (identifier) {
    var _a, _b;

    onStart === null || onStart === void 0 ? void 0 : onStart();
    identifier ? (_a = enter.onStart) === null || _a === void 0 ? void 0 : _a.call(enter) : (_b = leave.onStart) === null || _b === void 0 ? void 0 : _b.call(leave);
  });
  var handleEnd = useRefCallback(function (identifier, animating) {
    var _a, _b;

    onEnd === null || onEnd === void 0 ? void 0 : onEnd(animating);
    identifier ? (_a = enter.onEnd) === null || _a === void 0 ? void 0 : _a.call(enter, animating) : (_b = leave.onEnd) === null || _b === void 0 ? void 0 : _b.call(leave, animating);
  });
  var animation = useCreateAnimation(element, _objectSpread(_objectSpread(_objectSpread({}, extra), show ? enter : leave), {}, {
    onReady: handleReady,
    onStart: handleStart,
    onEnd: handleEnd
  }));
  useEffect(function () {
    var init = initRef.current;
    initRef.current = true;

    if (!disabled && (init || show || allowLeaveFirst)) {
      return animation.start(show);
    }
  }, [show]);
  return animation;
}